import React from 'react';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const TransparentTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
    backgroundColor: 'transparent',
  },
});

export const PreviewImage = styled('img')(({ theme }) => ({
  maxWidth: 400,
  objectFit: 'contain',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[2],
}));

export const HintTrigger = styled('span', {
  shouldForwardProp: prop => prop !== 'dimmed',
})<{ dimmed?: boolean }>(({ theme, dimmed }) => ({
  ...theme.typography.caption,
  cursor: 'help',
  color: theme.palette.text.secondary,
  display: 'flex',
  alignItems: 'center',
  marginRight: theme.spacing(1),
  opacity: dimmed ? 0.6 : 1,
}));
